import { Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Permission } from './permissions';

@Injectable()
export abstract class AuthorizationService {
  abstract getIsAuthorized$(permission: Permission, subjectUniqueId?: string): Observable<boolean>;
  abstract getIsAuthorizedSignal(permission: Permission, subjectUniqueId?: string): Signal<boolean>;
  abstract getIsAuthorized(permission: Permission, subjectUniqueId?: string): boolean;
}
